import { format } from 'date-fns';

export const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value.toMillis === 'function') return new Date(value.toMillis());
  if (typeof value === 'object' && typeof value.seconds === 'number') {
    return new Date(value.seconds * 1000);
  }
  if (typeof value === 'number') {
    const ms = value < 1e12 ? value * 1000 : value;
    const date = new Date(ms);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof value === 'string') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  return null;
};

export const formatDateTime = (value, pattern = 'dd MMM yyyy HH:mm') => {
  const date = toDate(value);
  return date ? format(date, pattern) : '';
};

export const normalizeMeetingType = (type) => {
  if (type == null) return null;
  if (typeof type === 'string' && type.trim() === '') return null;
  const numeric = typeof type === 'string' ? Number(type) : type;
  return Number.isFinite(numeric) ? numeric : type;
};

export const meetingTypeLabel = (type) => {
  const normalized = normalizeMeetingType(type);
  switch (normalized) {
    case 0:
      return 'Fiziksel';
    case 1:
      return 'Online';
    case 2:
      return 'Hibrit';
    case 3:
      return 'Telefon';
    case 4:
      return 'Yazışma';
    default:
      return 'Diğer';
  }
};

export const isActivityValue = (value) => {
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return !!value;
};

export const isActivityMeeting = (item) =>
  isActivityValue(item?.isactivity ?? item?.isActivity);

export const pickMeetingId = (item) => item?.meetingId ?? item?.id ?? item?._id ?? null;

export const getDetailPath = (item) => {
  const id = pickMeetingId(item);
  if (!id) return '';
  return `${isActivityMeeting(item) ? '/EventDetail' : '/MeetingDetail'}/${id}`;
};
